export enum OfferRenewalErrorStatus {
  InvalidReference = 'INVALID_REFERENCE',
  InvalidStatus = 'INVALID_STATUS',
  PlanLapsed = 'PLAN_LAPSED',
  PlanSkipped = 'PLAN_SKIPPED',
  PlanOfferNotFound = 'PLAN_OFFER_NOT_FOUND',
  UserNotAllowed = 'USER_NOT_ALLOWED_TAKE_OFFER',
}
